import { AlertTriangle } from 'lucide-react';

interface SearchWarningNoticeProps {
  /** Already translated. */
  message: string;
  testId: string;
  className?: string;
}

/**
 * The shell of a warning next to search results — one markup for every notice
 * that says the results are not the whole answer, so a styling or a11y change
 * lands in all of them at once.
 */
export function SearchWarningNotice({
  message,
  testId,
  className = '',
}: SearchWarningNoticeProps) {
  return (
    <div
      data-testid={testId}
      role="status"
      className={`flex items-start gap-1.5 text-xs text-warning ${className}`}
    >
      <AlertTriangle className="h-3.5 w-3.5 shrink-0 mt-px" aria-hidden="true" />
      <span>{message}</span>
    </div>
  );
}
